
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={},$1={payload: true,payload: true};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/sitemap.xsl"){r.unshift({data:$0});}else if(p==="/sitemap.xml"){r.unshift({data:$1});}return r;}})()
      export default (path) => defu({}, ...matcher('', typeof path === 'string' ? path.toLowerCase() : path).map(r => r.data).reverse())
      